export default {
  // 去除首尾空格
  trim: (str) => {
    let reg = /(^\s+)|(\s+$)/g; //匹配首尾空格
    if (typeof(str) === 'string') {
      return str.replace(reg,'')
    }
  },

  // 判断数据是否为空或者无效数据(true：无效数据, false：有效数据)
  isInvalid: (obj) => {
    return typeof obj === "undefined" || obj == null || obj === ""
  }
}
